import Cookies from 'js-cookie'

//#region jsCookies存储
const TokenKey = 'system_tokenKey'
const minutesTime = 15 // 多少分钟过期
let millisecond = new Date().getTime()
let expires = new Date(millisecond + 60 * 1000 * minutesTime) // 过期时间，分钟计算，值为 minutesTime

// 获取token
export function getToken() {
  return Cookies.get(TokenKey) || ''
}
// 设置token
export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 1 }) // 1天失效
  // return Cookies.set(TokenKey, token, { expires: expires }) // 15分钟失效
}
// 移除token
export function removeToken() {
  return Cookies.remove(TokenKey)
}
//#endregion

export function getItem(key) {
  try {
    return JSON.parse(localStorage.getItem(key))
  } catch (error) {
    return null
  }
}

export function setItem(key, value) {
  localStorage.setItem(key, JSON.stringify(value))
}

export function removeItem(key) {
  localStorage.removeItem(key)
}

export function clearItem() {
  localStorage.clear()
}
